import { render, staticRenderFns } from "./amendments.vue?vue&type=template&id=661c7b25&scoped=true"
import script from "./amendments.vue?vue&type=script&lang=js"
export * from "./amendments.vue?vue&type=script&lang=js"
import style0 from "./amendments.vue?vue&type=style&index=0&id=661c7b25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c7b25",
  null
  
)

export default component.exports